<div class="navigation-left">
  <a (click)="goBack()" class="arrow" data-testid="go-to-account-list"
    ><mat-icon>chevron_left</mat-icon> <span translate="accounts/edition/back_to_accounts_table"></span
  ></a>
</div>

<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span translate="add-account/vonage/title"></span>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div>
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="radio">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; index as index">
            <mat-radio-group [(ngModel)]="selectedNumber">
              <mat-radio-button
                class="example-radio-button"
                [value]="element"
                [disabled]="element.applicationId"
                [attr.data-testid]="'radio-row-' + index"></mat-radio-button>
            </mat-radio-group>
          </td>
        </ng-container>

        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate="add-account/vonage/phone-number"></span>
          </th>
          <td mat-cell *matCellDef="let element; index as index" [attr.data-testid]="'phone-row-' + index">
            {{ element.phoneNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="businessName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate="add-account/vonage/account-name"></span>
          </th>
          <td mat-cell *matCellDef="let element; index as index" [attr.data-testid]="'name-row-' + index">
            {{ element.businessName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="applicationId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header><span translate="add-account/vonage/app-id"></span></th>
          <td mat-cell *matCellDef="let element; index as index" [attr.data-testid]="'app-id-row-' + index">
            {{ element.applicationId }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; index as index; columns: displayedColumns"
          [attr.data-testid]="'row-' + index"
          [class.disabled]="row.applicationId"
          (click)="selectRow(row)"></tr>
      </table>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <div class="buttons">
      <button
        mat-flat-button
        color="primary"
        [disabled]="!selectedNumber"
        (click)="connect()"
        data-testid="connect-number"
        translate="add-account/vonage/button/connect"></button>

      <button mat-flat-button (click)="cancel()" data-testid="cancel-selection" translate="cancel"></button>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons> </mat-paginator>
  </mat-card-actions>
</mat-card>
